import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Location } from '@angular/common';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from 'htx-ui-library';

@Component({
  selector: 'app-terms-page',
  standalone: true,
  imports: [TranslocoDirective, TranslocoPipe, ButtonComponent],
  templateUrl: './terms-page.component.html',
  styleUrl: './terms-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsPageComponent {
  private location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
